import overArg from './_overArg.js';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

export default nativeKeys;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_nativeKeys.js
// module id = 477
// module chunks = 31 32 33 34 35